import { Sound } from "@/enums/Sound";
import activityAlert from "@/assets/sound/activity_alert.mp3";
import itemUnlocked from "@/assets/sound/award_1.mp3";
import levelUp from "@/assets/sound/level_up_3.mp3";
import babaYetu from "@/assets/sound/ambience_beweegbuddy_1.mp3";

export default class SoundLibrary
{
    static soundRepository = {
        [Sound.NOTIFICATION]: activityAlert,
        [Sound.APPLAUSE]: activityAlert,
        [Sound.ACTIVITYSTARTED]: activityAlert,
        [Sound.LEVELUP]: levelUp,
        [Sound.ITEMUNLOCKED]: itemUnlocked,
        [Sound.INTROSOUND]: activityAlert,
        [Sound.BABAYETU]: babaYetu
    }

    static getSound(soundId)
    {
        return SoundLibrary.soundRepository[soundId];
    }
}